import { useLocation } from "react-router-dom";
import { useMrReceiptQuery } from "../../features/api/transactionApi";
import numberToWords from "number-to-words";
import headerLogo from "../../asset/johura_logo.png";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { bankList } from "../../data";

const styles = StyleSheet.create({
  page: {
    // backgroundColor: "white",
    // paddingBottom: "88pt",
    backgroundColor: "#fff",
    padding: "0.7cm",
  },
  header: {
    // display:'flex',
    // flexDirection:'column',
    // justifyContent:'space-between',
    // alignItems:'center'
    // marginBottom: 5,
    // textAlign: "center",
    // height: "3.8cm",
  },

  footerAddr: {
    fontSize: "9px",
    textAlign: "center",
    width: "55%",
    margin: " auto",
    // width: "100%",
    // fontWeight: "thin",
  },
});

const Receipt = () => {
  const location = useLocation();
  const state = location?.state;

  const mrReceipt = useMrReceiptQuery(state, {
    refetchOnMountOrArgChange: true,
  })?.data;

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }


  return (
    <div>
      <div className="w-full lg:max-w-[1280px] px-6 lg:px-auto mx-auto h-[90vh] overflow-auto">
        <PDFViewer style={{ width: "100%", height: "100%" }}>
          <Document>
            <Page size="A5" orientation="landscape" style={styles.page}>
              {/* Header */}
              <View style={styles.header}>
                <View>
                  <View style={{ width: "60%", margin: "auto" }}>
                    <Image
                      src={headerLogo}
                      style={{ height: "20px", marginBottom: "5px" }}
                    />
                  </View>
                  <View style={styles.footerAddr}>
                    <Text>
                      15/A Zigatola, Hafizullah Green Tower, Flat # C1,
                      Dhanmondi, Dhaka - 1209
                    </Text>
                    <Text>
                      Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                      jahangirjohura@gmail.com / Web: www.johurabd.com
                    </Text>
                  </View>
                </View>
              </View>

              {/* Money Receipt */}
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "10px",
                  alignItems: "center",
                  fontSize: "12px",
                }}
              >
                <Text style={{ backgroundColor: "" }}>
                  MR No.: {mrReceipt?.mr_no}
                </Text>
                <View style={{ padding: "2px", backgroundColor: "black" }}>
                  <Text
                    style={{
                      color: "white",
                      padding: "4px",
                      border: "1px solid white",
                      fontWeight: "",
                    }}
                  >
                    MONEY RECEIPT
                  </Text>
                </View>
                <Text style={{ backgroundColor: "" }}>
                  MR Date: {formatDate(mrReceipt?.mr_date)}
                </Text>
              </View>

              {/* Body */}
              <View
                style={{
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "25%" }}>
                    Received with thanks from
                  </Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "75%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {mrReceipt?.client}
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "3%" }}>Of</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "97%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    JOHURA
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "12%" }}>Sum of Taka</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "88%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                      textTransform: "capitalize",
                    }}
                  >
                    {typeof mrReceipt?.credit_amount !== "number" ||
                    !isFinite(mrReceipt?.credit_amount)
                      ? "error"
                      : numberToWords.toWords(mrReceipt?.credit_amount)}{" "}
                    Taka Only
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <Text style={{ width: "32%" }}>
                    as a Payment againest the bill No
                  </Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "43%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {mrReceipt?.narr}
                  </Text>
                  <Text style={{ width: "5%" }}>Date</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "20%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {mrReceipt?.inv_date
                      ? formatDate(mrReceipt?.inv_date)
                      : null}
                  </Text>
                </View>
                <View
                  style={{
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  {/* <Text style={{ width: "15%" }}>Cash/Cheque</Text> */}
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "20%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {mrReceipt?.p_method}
                  </Text>
                  <Text style={{ width: "5%" }}>Date</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "15%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {mrReceipt?.chq_date
                      ? formatDate(mrReceipt?.chq_date)
                      : null}
                  </Text>
                  <Text style={{ width: "5%" }}>Bank</Text>
                  <Text
                    style={{
                      borderBottom: "1px solid dotted",
                      borderStyle: "dotted",
                      width: "55%",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    {bankList?.find((bank) => bank?.id == mrReceipt?.bank_id)
                      ?.name || null}
                  </Text>
                </View>
                <View
                  style={{
                    marginTop: "10px",
                    fontSize: "12px",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Text>Tk</Text>
                  <Text
                    style={{
                      border: "1px solid gray",
                      // padding: "4px",
                      width: "120px",
                      textAlign: "center",
                      height: "25px",
                      paddingTop: "6px",
                      fontSize: "14px",
                    }}
                  >
                    {mrReceipt?.credit_amount}
                  </Text>
                </View>
              </View>

              {/* Footer */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  fontSize: "12px",
                  marginTop: "40px",
                }}
              >
                <Text style={{ fontStyle: "italic" }}>
                  This Receipt is valid subject to realisation
                </Text>
                <Text style={{ fontStyle: "italic" }}>
                  For Johura Endomed Solution
                </Text>
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </div>
      {/* <ReactToPrint
        trigger={() => (
          <h1 className="cursor-pointer flex items-center absolute right-5 gap-x-1 text-red-500">
            <AiFillPrinter /> Print
          </h1>
        )}
        content={() => componentRef.current}
        pageStyle="@page { size: A4;  margin: 1cm; } @media print { body { -webkit-print-color-adjust: exact; } }"
      /> */}

      {/* <div ref={componentRef}>
      <div className="flex flex-col  ">
            <div className="text-center w-full my-6 py-1 font-serif">
              <h1 className=" font-bold " style={{ letterSpacing: "4px" }}>
                Invoice
              </h1>
              <div className="text-center text-sm">
                <h2 className="font-bold">Pixel Graphics & Printers</h2>
                <p>
                  {" "}
                  51-51/A, Resorsfull Paltan City (G Floor), Purana Paltan Dhaka
                  - 1000.
                </p>
                <p>01757-672696</p>
                <p>
                  <span className="">Email:</span> pixelgraphicsp@gmail.com
                </p>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="text-sm">
                <h1>
                  <span className="font-bold md:mr-4">Name:</span>{" "}
                  {findDealer?.d_name}
                </h1>
                <h1>
                  <span className="font-bold md:mr-3">Phone:</span>{" "}
                  {findDealer?.d_phone}
                </h1>
                <h1>
                  <span className="font-bold md:mr-4">Email:</span>{" "}
                  {findDealer?.d_email}
                </h1>
                <h1>
                  <span className="font-bold">Address:</span>{" "}
                  {findDealer?.d_address}
                </h1>
              </div>
              <div className="text-sm">
                <h2>
                  <span className="font-bold">Receipt No:</span>{" "}
                  {matched?.invoice_id}
                </h2>
                <h2>
                  <span className="font-bold">MR Date:</span>{" "}
                  {formatDate(matched?.trDate)}
                </h2>
              </div>
            </div>
            <div className="flex justify-between gap-2 my-2 border-b border-gray-400 pb-1"></div>
            <div>
              <table className="min-w-full bg-white text-sm">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                      Payment Method
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                      Remarks
                    </th>

                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                      Deposit Amount
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                      Due Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {matched?.description}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {matched?.rmks && (
                        <textarea
                          value={matched?.rmks}
                          className="w-[300px] h-[70px] resize-none focus:outline-none cursor-not-allowed text-justify"
                        />
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {matched?.credit_amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {lastDue}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex justify-between mt-10 items-center">
              <p className="font-bold text-xs">
                Print Date & Time: {todaysDate} {bangladeshTime}
              </p>
              <p>
                <span className="font-bold text-xs">
                  Authorised Signature:{" "}
                </span>
                ...................................
              </p>
            </div>
          </div>
       
      </div> */}
    </div>
  );
};

export default Receipt;
